<template>
  <Modal title="Set prospecting cadence" :max-width="400" @close="$emit('close')">
    <div class="setCadenceBody">
      <p class="setCadenceIntro">
        Set cadence for {{ count }} candidate{{ count !== 1 ? 's' : '' }}.
        <span v-if="count > 1">Non-account candidates will be skipped.</span>
      </p>
      <select v-model="state" class="setCadenceSelect">
        <option value="active">Every {{ activeDays }}d</option>
        <option value="opportunistic">Every {{ opportunisticDays }}d</option>
        <option value="timed_followup">Timed follow-up</option>
        <option value="off">Off</option>
      </select>
      <input
        v-if="state === 'timed_followup'"
        type="date"
        v-model="date"
        class="setCadenceSelect"
      />
    </div>
    <template #footer>
      <button class="btn secondary" @click="$emit('close')">Cancel</button>
      <button
        class="btn primary"
        :disabled="busy || (state === 'timed_followup' && !date)"
        @click="$emit('confirm', state, state === 'timed_followup' ? new Date(date).toISOString() : null)"
      >
        {{ busy ? 'Updating…' : 'Set cadence' }}
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Modal from './Modal.vue'

const props = withDefaults(
  defineProps<{
    count: number
    busy: boolean
    initialState?: string
    initialDate?: string | null
    activeDays?: number
    opportunisticDays?: number
  }>(),
  { initialState: 'active', initialDate: null, activeDays: 1, opportunisticDays: 7 },
)

defineEmits<{
  close: []
  confirm: [state: string, date: string | null]
}>()

const state = ref(props.initialState)
const date = ref(props.initialDate ? props.initialDate.slice(0, 10) : '')
</script>

<style scoped>
.setCadenceBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}
.setCadenceIntro {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
  line-height: var(--lh-normal);
}
.setCadenceSelect {
  width: 100%;
  padding: var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-primary);
  background: var(--color-bg-surface);
}
</style>
